<div class="time-frame">
  <ng-container>
    <div class="custom-field-wrapper">
      <div class="custom-field">
        <div class="label">{{ "audience.timeframeLabel" | translate }}</div>
        <div class="timeframe-row">
          <div
            class="operator-box new-style-custom-input"
            [matMenuTriggerFor]="timeframeOperator !== AudienceFilterTimeOperators.AnyTime ? timeframeOperatorsDropdown : menuTrigger_2">
            <span class="operator-text">{{ "audience.timeframeOperators." + timeframeOperator | translate }}</span>
            &nbsp;
            @if (timeframeOperator === AudienceFilterTimeOperators.TimeWindow) {
              {{ daysFC.value }}
              @if (daysFC.value) {
                <span>&nbsp;{{ "generic.days_2" | translate | lowercase }}</span>
              }
            }
            @if (timeframeOperator === AudienceFilterTimeOperators.SinceDate) {
              {{ startDateFC.value | formatDate: "standartDateFromDate" }}
            }
            @if (timeframeOperator === AudienceFilterTimeOperators.BetweenDates) {
              {{ startDateFC.value | formatDate: "standartDateFromDate" }} and {{ endDateFC.value | formatDate: "standartDateFromDate" }}
            }
            @if (timeframeOperator === AudienceFilterTimeOperators.BetweenDaysAgo) {
              {{ daysStartFC.value }}&nbsp;
              @if ((daysEndFC.value || daysEndFC.value === 0) && (daysStartFC.value || daysStartFC.value === 0)) {
                <span>
                  {{ "generic.and" | translate }}
                </span>
              }
              &nbsp;{{ daysEndFC.value }}&nbsp;
              <span>{{ "dateRange.daysAgo" | translate }}</span>
            }
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <mat-menu #timeframeOperatorsDropdown="matMenu" class="time-frame-menu">
            <div class="operator-box" [ngClass]="timeframeOperator" [matMenuTriggerFor]="menuTrigger_2" (click)="onOpenSubMenu($event)">
              <span class="operator-text">{{ "audience.timeframeOperators." + timeframeOperator | translate }}</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
            <div (click)="onOpenSubMenu($event)" class="time-frame-menu-content" [ngClass]="timeframeOperator">
              @if (timeframeOperator === AudienceFilterTimeOperators.TimeWindow) {
                <mat-form-field class="new-style-input number-input-field" appearance="outline" [class.invalid]="timeframeValueError">
                  <input matInput type="number" [formControl]="daysFC" [min]="1" [max]="365" required />
                </mat-form-field>
                <div class="label">&nbsp;&nbsp;{{ "generic.days_2" | translate | lowercase }}</div>
              }
              @if (timeframeOperator === AudienceFilterTimeOperators.SinceDate || timeframeOperator === AudienceFilterTimeOperators.BetweenDates) {
                <mat-form-field class="new-style-input date-field" appearance="outline">
                  <input matInput [matDatepicker]="startDateDatePicker" [formControl]="startDateFC" required />
                  <mat-datepicker-toggle matSuffix [for]="startDateDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDateDatePicker></mat-datepicker>
                </mat-form-field>
              }
              @if (timeframeOperator === AudienceFilterTimeOperators.BetweenDates) {
                <span class="and">&nbsp;{{ "generic.and" | translate }}&nbsp;</span>
                <mat-form-field class="new-style-input date-field" appearance="outline">
                  <input matInput [matDatepicker]="endDateDatePicker" [min]="startDateFC.value" [formControl]="endDateFC" required />
                  <mat-datepicker-toggle matSuffix [for]="endDateDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDateDatePicker></mat-datepicker>
                </mat-form-field>
              }
              @if (timeframeOperator === AudienceFilterTimeOperators.BetweenDaysAgo) {
                <mat-form-field class="new-style-input number-input-field" appearance="outline" required>
                  <input matInput type="number" [min]="1" [max]="365" [formControl]="daysStartFC" required />
                </mat-form-field>
                <span class="and">&nbsp;{{ "generic.and" | translate }}&nbsp;</span>
                <mat-form-field class="new-style-input number-input-field" appearance="outline" required>
                  <input matInput type="number" [formControl]="daysEndFC" [min]="1" [max]="365" required />
                </mat-form-field>
                &nbsp;
                <span>{{ "dateRange.daysAgo" | translate }}</span>
              }
            </div>
          </mat-menu>
          <mat-menu #menuTrigger_2="matMenu" class="operators-dropdown-menu">
            <div>
              @for (operator of TimeframeOperators; track operator) {
                <div>
                  <button mat-menu-item (click)="onCloseSubMenuTimeFrame($event, operator)">
                    @if (operator !== AudienceFilterTimeOperators.BetweenDaysAgo) {
                      {{ "audience.timeframeOperators." + operator | translate }}
                    } @else {
                      {{ "audience.timeframeOperators.daysAgo" | translate }}
                    }
                  </button>
                </div>
              }
            </div>
          </mat-menu>
        </div>
      </div>
      @if (timeframeValueError) {
        <div class="timeframe-validation-row">{{ timeframeValueError | translate }}</div>
      }
    </div>
  </ng-container>
</div>
